module.exports = __webpack_public_path__ + "img/cards_icon.30bbd430.svg";